import { createSlice } from "@reduxjs/toolkit";

interface CompaniesState {
}

const initialState: CompaniesState = {
};

const companiesSlice = createSlice({
  name: "companies/slice",
  initialState,
  reducers: {}
});


export default companiesSlice.reducer;
